export type ModalSize = 'sm' | 'md' | 'lg';

export const MODAL_SIZE_WIDTH: Record<ModalSize, number> = {
  sm: 504,
  md: 680,
  lg: 856,
};

export type ModalMobileVariant = 'drawer' | 'modal';

export type ModalDialogIcon = 'warning' | 'checkmark' | 'loading' | 'error' | null;
